import React, { useEffect, useRef, useState } from "react";
import { valueCheckGlobalForFinancials } from "../../../GlobalFunctions";
import { useCookies } from "react-cookie";
import LoadingImage from "../../../assets/media/loader.gif";
import { Button, Modal, SegmentedControl, Select } from "@mantine/core";
import { Link, useLocation } from "react-router-dom";
import Header from "../../../common/header/header";
import Search2 from "../search2";
import Nav from "../nav";
import {
  baseUrl,
  modal_chart_icon,
  modal_table_icon,
  modal_excel_icon,
} from "../../../api/baseUrl";
import ComparisonChartModal from "../../../layout/modals/ComparisonChartModal";
import Peercomparasion from "../../comparison";
import * as XLSX from "xlsx";
import { IconChevronDown } from "@tabler/icons-react";

const IncomeTable = (props) => {
  const location = useLocation();
  let compId = location.state != undefined ? location.state.id : 189;
  const [companyId, setCompanyId] = useState(compId);
  const [errorMessage, setErrorMessage] = useState("");
  const [company, setCompany] = useState({});
  const [incomeStatement, setIncomeStatement] = useState([]);
  const [filteredStatement, setFilteredStatement] = useState([]);
  const [is, setIs] = useState([]);
  const [cookies] = useCookies();
  const [isLoading, setIsLoading] = useState(false);
  const [value, setValue] = useState("annual");
  const icon = <IconChevronDown size={16} />;
  const [startPeriod, setStartPeriod] = useState("");
  const [endPeriod, setEndPeriod] = useState("");
  const [searchClicked, setSearchClicked] = useState(false);
  const [tableActive, setTableActive] = useState(false);
  const [chartActive, setChartActive] = useState(false);
  const [companyName, setCompanyName] = useState();
  const [label, setLable] = useState("");
  const [chartData, setchartData] = useState([]);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalData, setModalData] = useState(null);

  useEffect(() => {
    fetch(`${baseUrl}/is/${companyId}`, {
      headers: {
        Authorization: `Bearer ${cookies?.accessToken}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setIs(data);
        setIncomeStatement(data[value]);
        setIsLoading(true);
      });
  }, [companyId]);

  useEffect(() => {
    if (!incomeStatement.length) return;

    const periods = incomeStatement[0]?.data.map((d) =>
      value === "quarter" ? `${d.year} Q${d.quarter}` : d.year.toString()
    );

    const last11Periods = periods.slice(-11);
    setStartPeriod(last11Periods[0]);
    setEndPeriod(last11Periods[last11Periods.length - 1]);

    const filtered = incomeStatement.map((item) => ({
      ...item,
      data: item.data.slice(-11),
    }));
    setFilteredStatement(filtered);
  }, [incomeStatement, value]);

  useEffect(() => {
    if (searchClicked) {
      if (!incomeStatement.length) return;

      const startIdx = incomeStatement[0]?.data.findIndex((d) =>
        value === "quarter"
          ? `${d.year} Q${d.quarter}` === startPeriod
          : d.year.toString() === startPeriod
      );

      const endIdx = incomeStatement[0]?.data.findIndex((d) =>
        value === "quarter"
          ? `${d.year} Q${d.quarter}` === endPeriod
          : d.year.toString() === endPeriod
      );

      if (startIdx === -1 || endIdx === -1) {
        setErrorMessage("Invalid date range selected");
        return;
      }

      const sliceStart = Math.min(startIdx, endIdx);
      const sliceEnd = Math.max(startIdx, endIdx) + 1;

      const filtered = incomeStatement.map((item) => ({
        ...item,
        data: item.data.slice(sliceStart, sliceEnd),
      }));
      setFilteredStatement(filtered);
      setErrorMessage("");
      setSearchClicked(false);
    }
  }, [incomeStatement, startPeriod, endPeriod, searchClicked, value]);

  const handleSwitch = (val) => {
    setIncomeStatement(is[val]);
    setValue(val);
    setSearchClicked(false);
  };

  const handleSearch = () => {
    setSearchClicked(true);
  };

  const tableContainerRef = useRef(null);

  useEffect(() => {
    if (filteredStatement.length && isLoading && tableContainerRef.current) {
      tableContainerRef.current.scrollLeft = tableContainerRef.current.scrollWidth;
    }
  }, [filteredStatement, isLoading]);

  const handleClear = () => {
    if (!incomeStatement.length) return;

    const periods = incomeStatement[0]?.data.map((d) =>
      value === "quarter" ? `${d.year} Q${d.quarter}` : d.year.toString()
    );
    const last11Periods = periods.slice(-11);

    setStartPeriod(last11Periods[0]);
    setEndPeriod(last11Periods[last11Periods.length - 1]);

    const filtered = incomeStatement.map((item) => ({
      ...item,
      data: item.data.slice(-11),
    }));
    setFilteredStatement(filtered);
    setErrorMessage("");
  };

  const handleExport = () => {
    const table = document.getElementById("table");
    const wb = XLSX.utils.table_to_book(table, { sheet: "file" });
    XLSX.writeFile(wb, `${company.name} - (${value}) Income Statement.xlsx`);
  };

  const handleChartModal = (companyName, label, chartData) => {
    setCompanyName(companyName);
    setLable(label + " - PKR(mn)");
    setchartData(chartData);
    setChartActive(true);
  };

  const handleModel = (status, item) => {
    setModalStatus(status);
    setModalData(item);
  };

  const close = () => {
    setModalStatus(false);
    setModalData(null);
  };

  return (
    <>
      <Header />
      <Search2
        companyId={companyId}
        setCompanyId={setCompanyId}
        setCompany={setCompany}
      />
      <Nav companyId={companyId} />

      {filteredStatement.length && isLoading ? (
        <div className="dashboard-main container container_box">
          {/* Date Dropdowns */}
          <div className="row mb-2 income-date-range-tbl">
            <div className="col-md-2">
              <Select
                data={incomeStatement[0]?.data.map((d) => ({
                  value: value === "quarter" ? `${d.year} Q${d.quarter}`: d.year.toString(),
                  label: value === "quarter" ? `${d.year}` : d.year.toString(),
                }))
                .reverse()
                }
                value={startPeriod}
                onChange={(val) => setStartPeriod(val)}
                withinPortal
                label="Start date"
                className="date-field"
                rightSection={icon}
                searchable
                nothingFound="No period found"
                styles={{ input: { height: "38px" } }}
              />
            </div>
            <div className="col-md-2 pl-0">
              <Select
                data={incomeStatement[0]?.data.map((d) => ({
                  value: value === "quarter" ? `${d.year} Q${d.quarter}`: d.year.toString(),
                  label: value === "quarter" ? `${d.year}` : d.year.toString(),
                }))
                .reverse()
                }
                value={endPeriod}
                onChange={(val) => setEndPeriod(val)}
                label="End date"
                withinPortal
                className="date-field"
                rightSection={icon}
                searchable
                nothingFound="No period found"
                styles={{ input: { height: "38px" } }}
              />
            </div>
            <div className="search-clear-button align-items-start cement-search-btn income-search-button">
              <Button className="search-btn-stle" onClick={handleSearch}>
                Search
              </Button>
              <Button
                className="search-btn-stle clear-btn-stl"
                onClick={handleClear}
              >
                Clear
              </Button>
              {errorMessage && (
                <h1
                  style={{
                    color: "red",
                    marginTop: "10px",
                    fontSize: "14px",
                  }}
                >
                  {errorMessage}{" "}
                </h1>
              )}
            </div>
          </div>
          <div className="annual-flex">
            <div>
              <SegmentedControl
                value={value}
                onChange={handleSwitch}
                data={[
                  { label: "Annual", value: "annual" },
                  { label: "Quarterly", value: "quarter" },
                ]}
              />
            </div>
            <div>
              <button
                onClick={handleExport}
                className="custom-export-button download-table-xls-button income-excel-btn"
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html: modal_excel_icon,
                  }}
                />
              </button>
            </div>
          </div>
          {/* Table */}
          <div className="ask-table-format ask-top-space table-scroll-responsive table-first-child income-fixed-row"
          ref={tableContainerRef}
          >
            <table id="table" className="table table-responsive">
              <thead className="fixed-rows">
                <tr>
                  <th style={styles.stickyColumn} colSpan={2}>Income Statement - PKR (mn)</th>
                  <th export={false}></th>
                  <th export={false}></th>
                  {filteredStatement[0]?.data.map((y, i) => (
                    <th key={i} className="right-align">
                      {value === "quarter" ? `${y.year}` : y.year}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody >
                {filteredStatement.map((r, i) => {
                  const abc = r.data.map((el) => el.value);
                  return (
                    <tr key={i} className={`${r.bold == 1 ? "bold" : ""} border-btm-remove`}>
                      <td colSpan={2} style={styles.stickyColumn}>{r.label}</td>
                      <td>
                        <div className="income-chart-grid">
                          <span
                            style={styles.chart}
                            onClick={() =>
                              handleChartModal(company.name, r.label, r.data)
                            }
                          >
                            <div
                              dangerouslySetInnerHTML={{
                                __html: modal_chart_icon,
                              }}
                            />
                          </span>
                          <span style={styles.chart}>
                            <Link
                              onClick={() =>
                                handleModel(
                                  true,
                                  `/comparison/incomestatement/${value}/${company.symbol}/${r.description_id}`
                                )
                              }
                            >
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: modal_table_icon,
                                }}
                              />
                            </Link>
                          </span>
                        </div>
                      </td>
                      <td>
                        <img
                          src={`https://quickchart.io/chart?bkg=transparent&c={type:%27sparkline%27,data:{datasets:[{backgroundColor:%20%27rgba(24,183,21,%200.1)%27,fill:true,borderWidth:8,borderColor:%27rgb(24,183,21)%27,data:[${abc.toString()}]}]}}`}
                          width="50px"
                          height="20px"
                        />
                      </td>
                      {r.data.map((d, j) => (
                        <td key={j} className="right-align">
                          {valueCheckGlobalForFinancials(d.value)}
                        </td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <div className="main-loader d-flex flex-column justify-content-center align-items-center">
          <img src={LoadingImage} style={{ height: "500px" }} />
        </div>
      )}

      <Modal
        opened={modalStatus}
        onClose={close}
        title="Peer Comparison"
        centered
        size="65rem"
        closeOnClickOutside={false}
      >
        <Peercomparasion datas={modalData} />
      </Modal>

      {chartActive && (
        <ComparisonChartModal
          chartActive={chartActive}
          setChartActive={setChartActive}
          companyname={companyName}
          label={label}
          chartData={chartData}
          slice={false}
        />
      )}
    </>
  );
};

const styles = {
  chart: {
    cursor: "pointer",
    float: "left",
    padding: "0px 10px 0 0px",
  },
  stickyColumn: {
    position: "sticky",
    left: "0px",
    zIndex: "1",
  },
};

export default IncomeTable;